import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import {SessionStore} from '../../store';
import {IBaseResponse, WebService} from '../../services';

type TStyles = Record<string, string>;
type TStyleMap = Record<string, TStyles>;
type TResponseJSON = IBaseResponse<{ json: string }>;

/**
 * expected-but-not-enforced structure of layoutBuilderElementConfigMap.json
 */
interface ILBElementConfig {
	brandConfig?: Record<string, string>;
	component: string;
	style?: TStyles;
}


@Module({name: 'elementConfig', namespaced: true})
export class ElementConfigModule extends VuexModule {
	config: Record<string, ILBElementConfig> = {};

	get brandConfig() {
		return SessionStore.brandConfig as Record<string, string> | null;
	}

	get styleConfig(): TStyleMap {
		const keys = Object.keys(this.config);
		const styles: TStyleMap = {};

		keys.forEach(key => {
			const config = this.config[key];

			// interpret/convert brand config tokens

			let color = '';
			if(typeof config?.brandConfig?.color === 'string') {
				color = this.brandConfig?.[config.brandConfig.color] ?? ''; // e.g., this.brandConfig.navColor
			}

			let fontFamily = '';
			if(typeof config?.brandConfig?.font !== 'undefined') {
				fontFamily = this.brandConfig?.[config.brandConfig.font] ?? '';
			}

			// grab all style-ready props
			const styleProps = config?.style as TStyles ?? {};

			styles[key] = {
				/*
				 * Unlike this method's Web Admin counterpart, backgroundColor shouldn't
				 * need to be set. If brandConfig is set and used correctly elsewhere in
				 * CP, then the background should already be that color.
				 */
				// backgroundColor: this.brandConfig?.backgroundColor ?? '',
				color,
				fontFamily,
				...styleProps,
			};
		});

		return styles;
	}


	@Action
	async fetchConfig() {
		const result = await WebService.unauthenticatedClient.get<TResponseJSON>('config_by_name', {
			params: {
				cfgName: 'layoutBuilderElementConfigMap'
			}
		});
		this.setConfig(result.data.data.json);
	}

	@Mutation
	setConfig(configJson: string) {
		this.config = JSON.parse(configJson);
	}
}
